import { decode as base64_decode, encode as base64_encode } from 'base-64';
import RootStore from './RootStore';
import { postApi, baseURL } from '../components/Utility'
import {
    action,

    makeObservable,
    observable,

} from 'mobx';


class ShiftLogReportStore {
    getDrivers = [];
    shiftLogReport = []
    total = 0
    loading = false
    rootStore

    constructor(rootStore) {
        makeObservable(this, {
            shiftLogReport: observable,
            total: observable,
            loading: observable,
            loadData: action,
            getDriversByCompanyId: action,

        });
        this.rootStore = rootStore;

    }

    async loadData({ offset, limit, companyId, vehicleId, fromDate, toDate, pageNo, filterBy, driverId }) {
        this.loading = true;
        console.log("Shift log Report")
        var postData = { "companyId": companyId, "vehicleId": vehicleId, 'filterBy': filterBy, "driverId": driverId, "fromDate": fromDate, "toDate": toDate, "offset": offset, "limit": limit, "page": pageNo }
        const base64Input = await base64_encode(JSON.stringify(postData));
        var response = await postApi.getClient().post("index.php?c=report&a=shiftlogReport", "postData=" + base64Input);

        this.shiftLogReport = response?.data?.data?.shiftLogReport

        this.total = parseInt(response?.data?.data?.TotalCount);
        this.loading = false;
    }

    async exportExcel(getData) {
        console.log("getData", getData);
        let lang = "english";
        window.location.href =
            baseURL +
            "index.php?c=report&a=exportShiftLogReportexcel&cid=" +
            getData.companyId +
            "&vid=" +
            getData.vehicleId +
            "&filterBy=" +
            getData.filterBy +
            "&did=" +
            getData.driverId +
            "&fD=" +
            getData.fromDate +
            "&tD=" +
            getData.toDate +
            "&colList=" +
            getData.colList +
            "&language=" +
            lang;
    }

    async exportpdf(getData) {
        let lang = "english";
        window.location.href =
            baseURL +
            "index.php?c=report&a=exportShiftLogReportpdf&cid=" +
            getData.companyId +
            "&vid=" +
            getData.vehicleId +
            "&filterBy=" +
            getData.filterBy +
            "&did=" +
            getData.driverId +
            "&fD=" +
            getData.fromDate +
            "&tD=" +
            getData.toDate +
            "&colList=" +
            getData.colList +
            "&language=" +
            lang;
    }

    async getDriversByCompanyId({ companyId }) {
        var postData = { companyId: companyId };
        const base64Input = await base64_encode(JSON.stringify(postData));
        var response = await postApi
            .getClient()
            .post("index.php?c=driver&a=getDriverData", "postData=" + base64Input);
        console.log(response, "post");
        this.getDrivers = response?.data?.data;
        return response?.data?.data;
    }



}

export default ShiftLogReportStore;
